module.exports = __webpack_public_path__ + "img/ogp.99cd307.png";